import { jsx as a, jsxs as r } from "react/jsx-runtime";
function n(e) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "21.5",
      height: "21.5",
      viewBox: "0 0 21.5 21.5",
      ...e,
      children: /* @__PURE__ */ r("g", { id: "Layer_2", "data-name": "Layer 2", transform: "translate(-1.25 -1.25)", children: [
        /* @__PURE__ */ a(
          "path",
          {
            id: "Tracé_43",
            "data-name": "Tracé 43",
            d: "M12,22.75A10.762,10.762,0,0,1,1.25,12a.75.75,0,0,1,1.5,0A9.25,9.25,0,1,0,12,2.75a.75.75,0,1,1,0-1.5,10.75,10.75,0,0,1,0,21.5Z",
            fill: "rgb(var(--rgb-color-orange))"
          }
        ),
        /* @__PURE__ */ a(
          "path",
          {
            id: "Tracé_44",
            "data-name": "Tracé 44",
            d: "M12,22.75a10.744,10.744,0,0,1-3.176-.477.75.75,0,1,1,.443-1.433A9.257,9.257,0,0,0,12,21.25a.75.75,0,1,1,0,1.5ZM5.56,20.4a.742.742,0,0,1-.483-.176A10.74,10.74,0,0,1,2.42,16.882.75.75,0,0,1,3.756,16.2a9.236,9.236,0,0,0,2.287,2.877A.749.749,0,0,1,5.56,20.4ZM2.144,14.456a.751.751,0,0,1-.738-.623,10.839,10.839,0,0,1,.121-4.267A.75.75,0,0,1,2.988,9.9a9.358,9.358,0,0,0-.1,3.675.75.75,0,0,1-.612.866.8.8,0,0,1-.132.015ZM3.909,6.872A.749.749,0,0,1,3.3,5.681,10.808,10.808,0,0,1,5.557,3.4a.75.75,0,0,1,.9,1.2A9.3,9.3,0,0,0,4.516,6.563a.75.75,0,0,1-.607.309ZM9.6,3.041a.75.75,0,0,1-.18-1.478A10.758,10.758,0,0,1,12,1.25a.75.75,0,1,1,0,1.5,9.255,9.255,0,0,0-2.224.27.8.8,0,0,1-.176.021Z",
            fill: "rgb(var(--rgb-color-orange))"
          }
        ),
        /* @__PURE__ */ r("g", { id: "Groupe_40", "data-name": "Groupe 40", children: [
          /* @__PURE__ */ a(
            "path",
            {
              id: "Tracé_45",
              "data-name": "Tracé 45",
              d: "M9.171,15.578a.75.75,0,0,1-.53-1.28L14.3,8.642A.75.75,0,0,1,15.359,9.7L9.7,15.358a.748.748,0,0,1-.529.22Z",
              fill: "rgb(var(--rgb-color-orange))"
            }
          ),
          /* @__PURE__ */ a(
            "path",
            {
              id: "Tracé_46",
              "data-name": "Tracé 46",
              d: "M14.829,15.578a.748.748,0,0,1-.531-.22L8.641,9.7A.75.75,0,0,1,9.7,8.642L15.359,14.3a.75.75,0,0,1-.53,1.28Z",
              fill: "rgb(var(--rgb-color-orange))"
            }
          )
        ] })
      ] })
    }
  );
}
export {
  n as StatusCanceling
};
